import { getRequest, postRequest, putRequest, deleteRequest } from "./api.request";

const DYNAMIC_TEMPLATE_PATH = "/dynamic-template/v1";

export const getDynamicTemplateApi = async (params, options = {}) => await getRequest(DYNAMIC_TEMPLATE_PATH, params, options);

export const getDynamicTemplateByIdApi = async (id) =>
  await getRequest(`${DYNAMIC_TEMPLATE_PATH}/${id}`, {});

export const addDynamicTemplateApi = async (body) =>
  await postRequest(DYNAMIC_TEMPLATE_PATH, body);

export const updateDynamicTemplateApi = async (id, body) =>
  await putRequest(`${DYNAMIC_TEMPLATE_PATH}/${id}`, body);

export const deleteDynamicTemplateApi = async (id) =>
  await deleteRequest(`${DYNAMIC_TEMPLATE_PATH}/${id}`);
